<template>
	<article 
		:id="id" 
		:class="[
			'dc-post-grid-card company-card light-bg-theme has-shadow'
		]">
		<div class="company-card-inner">
			<div v-if="image" class="image-wrapper">
				<img :src="image.src" :srcset="image.srcset" :alt="image.alt" />
			</div>
			<div class="content-wrapper">
				<h1 v-if="name" class="company-name">{{ name }}</h1>
				<div v-if="bio" v-html="bio"></div>
				<a v-if="website" :href="website" class="dc-button primary">Visit website</a>
			</div>
		</div>
	</article>
</template>

<script>
export default {
	props: {
	    id: {
	      type: String,
	      required: true
	    },
		name: {
	      type: String,
	      required: true
	    },
		website: {
	      type: String,
	      required: true
	    },
		bio: {
	      type: String,
	      required: false
	    },
		image: {
	      type: Object,
	      required: false
	    },
	}
}
</script>